/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./subItem.vue?vue&type=template&id=2052600b"
import script from "./subItem.vue?vue&type=script&lang=js"
export * from "./subItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports